import React from 'react';
import { FormNumber, Selectize, TextArea, FormSelect } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';

import { PROMPT_OPTIONS, GIVEN_TYPE_OPTIONS } from '~/config/constants';

function PromptDetail() {
    const { cardMetaData } = useFormTab();
    const { effects, conditions, prompts } = cardMetaData;

    return (
        <>
            {JSON.stringify(cardMetaData) !== '{}' && (
                <>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptEffects"
                            sm={6}
                            options={prompts || []}
                            tooltip="Which type of prompt to ask player when effect runs?"
                        />
                        <TextArea
                            name="promptDetail.promptDescription"
                            rows={2}
                            sm="3"
                            tooltip="Prompt Description question that the player will answer."
                        />
                        <FormSelect
                            name="promptDetail.promptOption"
                            options={PROMPT_OPTIONS || []}
                            sm={3}
                            tooltip="For which sequence the prompt is being asked for?"
                        />
                    </Form.Row>
                    <hr></hr>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptChoice1Effects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="First effect to run as a result of player's option selected in the prompt."
                        />
                        <TextArea
                            name="promptDetail.promptChoice1Description"
                            rows={2}
                            sm="6"
                            tooltip="Description of the choice."
                        />
                        <FormSelect
                            name="promptDetail.promptChoice1RequirementOption"
                            options={GIVEN_TYPE_OPTIONS || []}
                            sm={3}
                            tooltip="Requirement for player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice1RequirementValue"
                            sm={3}
                            tooltip="Requirement value for the player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice1DvValue"
                            sm={3}
                            tooltip="N/A."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice1DamageValue"
                            sm={3}
                            tooltip="N/A."
                        />
                    </Form.Row>
                    <hr></hr>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptChoice2Effects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="Second effect to run as a result of player's option selected in the prompt."
                        />
                        <TextArea
                            name="promptDetail.promptChoice2Description"
                            rows={2}
                            sm={6}
                            tooltip="Description of the choice."
                        />
                        <FormSelect
                            name="promptDetail.promptChoice2RequirementOption"
                            options={GIVEN_TYPE_OPTIONS || []}
                            sm={3}
                            tooltip="Requirement for player to select this choice.."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice2RequirementValue"
                            sm={3}
                            tooltip="Requirement value for the player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice2DvValue"
                            sm={3}
                            tooltip="N/A."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice2DamageValue"
                            sm={3}
                            tooltip="N/A."
                        />
                    </Form.Row>
                    <hr></hr>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptChoice3Effects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="Third effect to run as a result of player's option selected in the prompt."
                        />
                        <TextArea
                            name="promptDetail.promptChoice3Description"
                            rows={2}
                            sm={6}
                            tooltip="Description of the choice."
                        />
                        <FormSelect
                            name="promptDetail.promptChoice3RequirementOption"
                            options={GIVEN_TYPE_OPTIONS || []}
                            sm={3}
                            tooltip="Requirement for player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice3RequirementValue"
                            sm={3}
                            tooltip="Requirement value for the player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice3DvValue"
                            sm={3}
                            tooltip="N/A."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice3DamageValue"
                            sm={3}
                            tooltip="N/A."
                        />
                    </Form.Row>
                    <hr></hr>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptChoice4Effects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="Fourth effect to run as a result of player's option selected in the prompt."
                        />
                        <TextArea
                            name="promptDetail.promptChoice4Description"
                            rows={2}
                            sm={6}
                            tooltip="Description of the choice."
                        />
                        <FormSelect
                            name="promptDetail.promptChoice4RequirementOption"
                            options={GIVEN_TYPE_OPTIONS || []}
                            sm={3}
                            tooltip="Requirement for player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice4RequirementValue"
                            sm={3}
                            tooltip="Requirement value for the player to select this choice."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice4DvValue"
                            sm={3}
                            tooltip="N/A."
                        />
                        <FormNumber
                            name="promptDetail.promptChoice4DamageValue"
                            sm={3}
                            tooltip="N/A."
                        />
                    </Form.Row>
                    <hr></hr>
                    <Form.Row>
                        <Selectize
                            name="promptDetail.promptChoiceValueEffects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="N/A."
                        />
                        <Selectize
                            name="promptDetail.promptChoiceBidEffects"
                            sm={6}
                            options={[...effects, ...conditions] || []}
                            tooltip="Bidding effects that occur after both players have bid from an effect. Ex: Bounty hunter."
                        />
                    </Form.Row>
                </>
            )}
        </>
    );
}

export default PromptDetail;
